export interface Article {
  slug: string;
  title: string;
  category: string;
  date: string;
  summary: string;
  content: string;
  image: string;
  tags: string[];
  author: string;
  readTime: string;
}

export const articles: Article[] = [
  {
    slug: "new-drama-2026-summer",
    title: "佐佐木明希主演夏季新剧《东京之恋》正式官宣，搭档人气男星引期待",
    category: "news",
    date: "2026-08-10",
    summary: "佐佐木明希确认将主演2026年夏季档新剧《东京之恋》，该剧改编自畅销小说，将在TBS电视台黄金时段播出，引发粉丝热烈讨论。",
    content: `<p>据日媒最新报道，人气女演员佐佐木明希已确认将主演TBS电视台2026年夏季档新剧《东京之恋》。该剧改编自作家村上春树的同名畅销小说，由知名导演是枝裕和执导。</p>
    <p>据悉，佐佐木明希在剧中饰演一位从地方城市来到东京追逐梦想的年轻女性——小野寺樱。故事围绕她在东京的生活、爱情与成长展开，描绘了当代年轻人在大都市中的奋斗与迷茫。</p>
    <p>与佐佐木明希搭档的男主角将由人气男星山崎贤人出演。两位实力派演员的首次合作令粉丝们倍感期待。制作方表示：「佐佐木小姐身上那种纯净又坚韧的气质，与樱这个角色完美契合。」</p>
    <p>该剧预计将于2026年7月在TBS电视台每周五晚10点播出，共10集。官方预告片将于6月中旬发布。佐佐木明希本人也在社交媒体上表达了对这部作品的期待：「樱是一个非常有层次的角色，我会全力以赴，希望能给大家带来感动。」</p>`,
    image: "https://readdy.ai/api/search-image?query=Japanese%20actress%20elegant%20portrait%20with%20warm%20natural%20lighting%20on%20white%20minimalist%20background%2C%20professional%20editorial%20photography%2C%20soft%20and%20dreamy%20atmosphere%2C%20gentle%20expression%2C%20cream%20tones%2C%20high%20fashion%20editorial%20style&width=800&height=500&seq=news-drama-2026&orientation=landscape",
    tags: ["新剧", "东京之恋", "TBS", "山崎贤人"],
    author: "编辑部",
    readTime: "5分钟",
  },
  {
    slug: "charity-event-2026-report",
    title: "佐佐木明希出席儿童教育公益晚宴，现场捐赠500万日元助力乡村教育",
    category: "news",
    date: "2026-08-05",
    summary: "佐佐木明希作为联合国儿童基金会亲善大使，出席年度慈善晚宴并发表感言，呼吁社会各界关注乡村儿童教育问题。",
    content: `<p>8月3日晚，佐佐木明希以联合国儿童基金会日本亲善大使身份出席了在东京帝国酒店举办的年度慈善晚宴。她身着一袭淡雅长裙亮相红毯，优雅大方的气质成为全场焦点。</p>
    <p>在晚宴上，佐佐木明希发表了关于乡村儿童教育的主题演讲。她分享了自己近期走访日本偏远地区学校的经历：「看到那些孩子们渴望知识的眼神，我深受触动。每个孩子都应该拥有公平的教育机会，这是我们这一代人的责任。」</p>
    <p>佐佐木明希个人通过其设立的「明希教育基金」向乡村教育项目捐赠了500万日元。在她的带动下，当晚共筹得善款超过3000万日元，将全部用于改善日本乡村地区的教育设施和师资培训。</p>
    <p>活动结束后，佐佐木明希在社交媒体上写道：「感谢每一位为孩子们的未来贡献力量的朋友。教育是改变命运的钥匙，让我们一起守护每个孩子的梦想。」这条动态获得了超过50万次点赞和数万条暖心评论。</p>`,
    image: "https://readdy.ai/api/search-image?query=elegant%20Japanese%20woman%20in%20elegant%20dress%20at%20charity%20gala%20event%2C%20warm%20golden%20lighting%2C%20sophisticated%20banquet%20hall%20background%2C%20graceful%20and%20inspiring%20atmosphere%2C%20editorial%20photography%20style%2C%20soft%20bokeh&width=800&height=500&seq=charity-2026&orientation=landscape",
    tags: ["公益", "儿童教育", "联合国儿童基金会", "慈善"],
    author: "编辑部",
    readTime: "4分钟",
  },
  {
    slug: "photobook-2026-release",
    title: "佐佐木明希全新写真集《明日的风景》即将发售，收录京都绝美写真",
    category: "photos",
    date: "2026-07-28",
    summary: "佐佐木明希第三本个人写真集《明日的风景》将于9月1日正式发售，全篇在京都取景拍摄，展现古都四季之美与人物的完美融合。",
    content: `<p>佐佐木明希的第三本个人写真集《明日的风景》正式定档9月1日发售。这本写真集历时半年制作，全篇在日本古都京都完成拍摄，由著名摄影师蜷川实花操刀。</p>
    <p>《明日的风景》以「时光与美的对话」为主题，收录了佐佐木明希在京都四季变换中的100余幅精美写真。从樱花纷飞的哲学之道到红叶似火的岚山竹林，从夏日的鸭川河畔到冬雪中的金阁寺，每一帧都宛如一幅绝美的画卷。</p>
    <p>写真集分为「春·初遇」、「夏·盛放」、「秋·沉淀」、「冬·静思」四个篇章，每个篇章都配有佐佐木明希亲笔撰写的散文随笔，分享她在京都拍摄期间的所思所感。</p>
    <p>佐佐木明希在发布会上表示：「京都是我心中最特别的城市。这次拍摄让我有机会静下心来，感受时间的流动和生命的美好。希望能通过这本写真集，把这份感动传递给每一位翻开它的人。」</p>
    <p>写真集定价4,800日元，初回限定版附赠签名明信片和拍摄花絮DVD，各大书店及线上平台同步发售。</p>`,
    image: "https://readdy.ai/api/search-image?query=Japanese%20actress%20in%20traditional%20kimono%20standing%20in%20Kyoto%20bamboo%20forest%2C%20soft%20natural%20sunlight%20filtering%20through%20bamboo%2C%20serene%20and%20elegant%20atmosphere%2C%20warm%20cream%20tones%2C%20editorial%20photography&width=800&height=500&seq=photobook-2026&orientation=landscape",
    tags: ["写真集", "京都", "蜷川实花", "明日的风景"],
    author: "编辑部",
    readTime: "6分钟",
  },
  {
    slug: "fan-meeting-osaka-2026",
    title: "佐佐木明希大阪粉丝见面会圆满落幕，千人会场座无虚席感动满满",
    category: "events",
    date: "2026-07-20",
    summary: "7月18日，佐佐木明希在大阪城Hall举办年度粉丝见面会，吸引超过3000名粉丝到场，现场气氛热烈温馨。",
    content: `<p>7月18日下午，佐佐木明希年度粉丝见面会「明希与你同行」在大阪城Hall隆重举行。尽管当天大阪气温高达35度，但粉丝们的热情丝毫不减，超过3000张门票在开售后3分钟内即告售罄。</p>
    <p>见面会以佐佐木明希的一曲钢琴独奏开场，她为大家演奏了自己最爱的肖邦《夜曲》。随后，她与粉丝们分享了近期的拍摄趣事、旅行见闻以及生活中的小确幸。现场笑声不断，气氛温馨融洽。</p>
    <p>活动的高潮是互动游戏环节——佐佐木明希随机抽取幸运粉丝上台，一起完成趣味问答和即兴表演。一位来自北海道的小粉丝激动地说：「我从中学就开始喜欢明希姐姐，今天终于见到真人，比想象中还要温柔！」</p>
    <p>见面会尾声，佐佐木明希演唱了她主演日剧的主题曲《星光的约定》，全场粉丝举起应援灯，汇成一片温暖的光海。她在台上感动落泪：「有你们陪伴的每一天，都是我人生中最珍贵的礼物。」</p>
    <p>据悉，下一场粉丝见面会将于10月在东京举办，具体信息将在官方社交媒体发布。</p>`,
    image: "https://readdy.ai/api/search-image?query=Japanese%20idol%20on%20stage%20at%20concert%20hall%20with%20warm%20spotlight%2C%20crowd%20holding%20light%20sticks%20creating%20beautiful%20light%20ocean%2C%20emotional%20atmosphere%2C%20warm%20golden%20and%20pink%20tones%2C%20concert%20photography&width=800&height=500&seq=fanmeeting-osaka&orientation=landscape",
    tags: ["粉丝见面会", "大阪", "互动", "演唱会"],
    author: "编辑部",
    readTime: "5分钟",
  },
  {
    slug: "magazine-cover-august",
    title: "佐佐木明希登《VOGUE Japan》八月刊封面，演绎夏日清新风尚",
    category: "photos",
    date: "2026-07-15",
    summary: "佐佐木明希首次登上《VOGUE Japan》封面，以多套夏日造型展现清新魅力，杂志内页专访畅谈事业与生活平衡。",
    content: `<p>佐佐木明希登上《VOGUE Japan》2026年8月刊封面，这是她首次成为这本顶级时尚杂志的封面人物。封面中，她身着简约白裙，在冲绳的碧海蓝天下绽放灿烂笑容，清新自然的风格获得时尚界一致好评。</p>
    <p>本期杂志以「夏日的诗」为主题，佐佐木明希在冲绳完成了为期三天的拍摄。她共变换了12套造型，从飘逸长裙到干练西装，从甜美碎花到极简黑白，全方位展现了她多变的时尚驾驭力。</p>
    <p>随刊附赠的深度专访中，佐佐木明希罕见地谈及了事业与个人生活的平衡之道。她坦言：「30岁之后，我学会了更加珍惜独处的时光。工作固然重要，但内心的平静同样不可或缺。现在我每周都会留出一天完全属于自己——阅读、弹钢琴、或者只是安静地散步。」</p>
    <p>当被问及未来的规划时，佐佐木明希表示希望尝试更多幕后工作：「我一直对编剧很感兴趣，也许以后会尝试写一个属于自己的故事。」</p>
    <p>本期《VOGUE Japan》8月刊已于7月15日全国发售，首周销量突破20万册。</p>`,
    image: "https://readdy.ai/api/search-image?query=Japanese%20actress%20fashion%20magazine%20cover%20style%20portrait%20on%20beach%2C%20white%20dress%20flowing%20in%20sea%20breeze%2C%20Okinawa%20blue%20ocean%20background%2C%20fresh%20summer%20vibes%2C%20high%20fashion%20editorial%20photography%2C%20bright%20natural%20light&width=800&height=500&seq=vogue-cover-2026&orientation=landscape",
    tags: ["VOGUE", "杂志封面", "时尚", "冲绳"],
    author: "编辑部",
    readTime: "4分钟",
  },
  {
    slug: "community-art-contest",
    title: "「我心中的明希」粉丝绘画大赛开启，优胜作品将获本人亲笔点评",
    category: "community",
    date: "2026-07-10",
    summary: "官方粉丝社区发起「我心中的明希」主题绘画大赛，邀请粉丝用画笔描绘心中的佐佐木明希形象，优秀作品将获官方认证与特别奖励。",
    content: `<p>佐佐木明希官方粉丝社区今日正式发起「我心中的明希」主题绘画大赛，邀请全球粉丝用画笔描绘他们心中最美的佐佐木明希形象。无论是写实肖像、动漫风格还是抽象创作，只要表达对明希的喜爱均可参赛。</p>
    <p>大赛分为「手绘组」和「数字绘画组」两个赛道，每位参赛者可提交最多3幅作品。投稿时间为7月10日至8月31日，评选结果将于9月15日公布。</p>
    <p>本次大赛的评委阵容包括佐佐木明希本人、知名插画师中村佑介以及《周刊少年Jump》美术总监。获得金奖的作品不仅能得到佐佐木明希的亲笔点评视频，还将被制作成限定周边商品。</p>
    <p>佐佐木明希在活动宣传视频中笑着说：「我超级期待看到大家的作品！每次在活动上看到粉丝们画的我都觉得特别温暖，这次终于可以好好欣赏一番了。请大家尽情发挥创意吧！」</p>
    <p>参赛方式：登录官方粉丝社区，在「创作天地」板块上传作品并添加话题 #我心中的明希# 即可。</p>`,
    image: "https://readdy.ai/api/search-image?query=colorful%20fan%20art%20illustrations%20and%20paintings%20displayed%20on%20gallery%20wall%2C%20warm%20creative%20atmosphere%2C%20art%20supplies%20and%20sketches%20on%20wooden%20table%2C%20soft%20natural%20lighting%2C%20cozy%20studio%20vibe%2C%20cream%20and%20pastel%20tones&width=800&height=500&seq=art-contest-2026&orientation=landscape",
    tags: ["绘画大赛", "粉丝社区", "创意", "互动"],
    author: "社区管理员",
    readTime: "3分钟",
  },
  {
    slug: "stage-play-hamlet-2026",
    title: "佐佐木明希挑战舞台剧《哈姆雷特》奥菲莉亚一角，演技再获突破",
    category: "works",
    date: "2026-06-25",
    summary: "佐佐木明希首次出演莎士比亚经典舞台剧，在新国立剧场连续公演20场，精湛演技获得评论界高度赞誉。",
    content: `<p>佐佐木明希首次挑战莎士比亚经典悲剧《哈姆雷特》，在东京新国立剧场饰演奥菲莉亚一角。这部由英国导演Trevor Nunn执导的全新制作版《哈姆雷特》自6月15日开演以来，场场爆满，好评如潮。</p>
    <p>佐佐木明希饰演的奥菲莉亚被认为是本版最令人惊喜的亮点之一。她将奥菲莉亚从天真无邪到精神崩溃的转变演绎得层层递进、细腻动人。特别是在第四幕的「疯歌」场景中，她以清唱方式演绎奥菲莉亚的悲歌，空灵的嗓音配合破碎的眼神，令无数观众动容落泪。</p>
    <p>《朝日新闻》戏剧评论家山田宏一评价道：「佐佐木明希的奥菲莉亚超越了语言和文化的界限。她不是在表演一个角色，而是真正成为了奥菲莉亚。这是近年来日本舞台上最令人难忘的表演之一。」</p>
    <p>据悉，佐佐木明希为这个角色准备了近半年时间，每天进行英语台词训练、声乐练习和形体训练。她谦虚地表示：「莎士比亚的作品是一座永远无法完全攀登的高峰。每一次演出，我都在学习和成长。」</p>
    <p>本轮公演将持续至7月10日，后续将在大阪和福冈进行巡演。</p>`,
    image: "https://readdy.ai/api/search-image?query=Japanese%20actress%20performing%20on%20theater%20stage%20in%20classical%20costume%2C%20dramatic%20stage%20lighting%20and%20atmospheric%20smoke%2C%20Shakespeare%20theater%20production%2C%20emotional%20performance%2C%20warm%20spotlight%2C%20professional%20theater%20photography&width=800&height=500&seq=stage-hamlet-2026&orientation=landscape",
    tags: ["舞台剧", "哈姆雷特", "莎士比亚", "新国立剧场"],
    author: "编辑部",
    readTime: "5分钟",
  },
  {
    slug: "tv-variety-special-2026",
    title: "佐佐木明希综艺首秀大获成功，《明希的厨房》节目收视率创纪录",
    category: "works",
    date: "2026-06-10",
    summary: "佐佐木明希首次担任综艺节目主持人，《明希的厨房》以温馨治愈的风格获得观众喜爱，首播收视率达12.8%。",
    content: `<p>佐佐木明希首次担任综艺节目主持人的美食节目《明希的厨房》于6月8日在朝日电视台首播，首集收视率高达12.8%，创下同时段综艺节目新高。</p>
    <p>《明希的厨房》是一档融合美食制作与人生故事的治愈系综艺。每期节目邀请一位嘉宾来到佐佐木明希的「厨房」，一边烹饪一道承载回忆的料理，一边分享人生中的温暖故事。首期嘉宾是知名演员阿部宽，两人共同制作了阿部宽母亲传下来的味噌汤。</p>
    <p>节目中的佐佐木明希展现了与以往不同的亲和力。她系着围裙在厨房忙碌的样子、品尝美食时幸福的表情、以及认真倾听嘉宾故事时的温柔眼神，都让观众看到了她真实可爱的一面。社交媒体上，「明希的厨房好看哭了」迅速登上热搜榜首。</p>
    <p>制作人田中伸一表示：「佐佐木小姐有一种让人卸下心防的魔力。嘉宾们在她面前都会不自觉地敞开心扉，这正是这档节目最珍贵的部分。」</p>
    <p>《明希的厨房》每周三晚9点在朝日电视台播出，目前已确认将制作第二季。</p>`,
    image: "https://readdy.ai/api/search-image?query=Japanese%20actress%20cooking%20in%20bright%20modern%20kitchen%20studio%2C%20wearing%20casual%20apron%2C%20warm%20smile%2C%20TV%20show%20set%20with%20fresh%20ingredients%20on%20wooden%20counter%2C%20cozy%20and%20inviting%20atmosphere%2C%20natural%20lighting&width=800&height=500&seq=tv-kitchen-2026&orientation=landscape",
    tags: ["综艺", "美食节目", "明希的厨房", "主持人"],
    author: "编辑部",
    readTime: "4分钟",
  },
  {
    slug: "tokyo-fan-meeting-announce",
    title: "佐佐木明希东京粉丝见面会定档10月，预售通道即将开启",
    category: "events",
    date: "2026-05-30",
    summary: "佐佐木明希官方宣布将于10月25日在东京巨蛋City Hall举办大型粉丝见面会「星辉之夜」，官方粉丝俱乐部会员可提前购票。",
    content: `<p>佐佐木明希官方团队今日正式宣布，将于2026年10月25日在东京巨蛋City Hall举办大型粉丝见面会「星辉之夜——佐佐木明希2026秋季粉丝见面会」。这是继大阪场圆满成功后，年度第二场大型粉丝活动。</p>
    <p>据悉，东京场将采用全新的沉浸式舞台设计，以「星空与梦想」为主题，打造一场视听盛宴。除了经典歌曲演唱和互动环节外，还将首次公开展示佐佐木明希的个人摄影作品展和未公开的幕后花絮视频。</p>
    <p>门票分为SS席（15,000日元）、S席（10,000日元）和A席（6,500日元）三个等级。SS席观众将额外获得限定周边礼包和活动后的线上签名会参与资格。</p>
    <p>官方粉丝俱乐部「明希会」会员可于8月1日起优先购票，普通售票将于8月15日开放。佐佐木明希通过视频向粉丝喊话：「东京的各位，让我们在金秋十月一起度过一个难忘的夜晚吧！我会准备很多惊喜给大家哦～」</p>`,
    image: "https://readdy.ai/api/search-image?query=Tokyo%20Dome%20City%20Hall%20exterior%20with%20evening%20lights%2C%20grand%20event%20venue%20atmosphere%2C%20warm%20golden%20illumination%2C%20urban%20Tokyo%20night%20scene%2C%20excitement%20and%20anticipation%20vibe%2C%20professional%20architectural%20photography&width=800&height=500&seq=tokyo-fanmeet-ann&orientation=landscape",
    tags: ["粉丝见面会", "东京", "10月", "预售"],
    author: "编辑部",
    readTime: "3分钟",
  },
  {
    slug: "brand-ambassador-2026",
    title: "佐佐木明希成为国际护肤品牌SK-II新任品牌大使，广告大片惊艳亮相",
    category: "news",
    date: "2026-05-15",
    summary: "国际知名护肤品牌SK-II正式宣布佐佐木明希成为其日本区品牌大使，全新广告大片在东京、纽约、巴黎三地同步上线。",
    content: `<p>国际知名护肤品牌SK-II今日正式宣布，佐佐木明希成为其日本区新任品牌大使。这是SK-II品牌历史上首次选择日本本土艺人担任该重要角色，标志着品牌对日本市场的进一步深耕。</p>
    <p>为庆祝此次合作，SK-II携手佐佐木明希拍摄了全新广告大片《透亮人生》。广告由奥斯卡获奖导演Florian Henckel von Donnersmarck执导，在东京、纽约、巴黎三地取景，展现了现代女性在不同文化背景下的自信与美丽。</p>
    <p>在广告中，佐佐木明希以素颜出镜，展示了她引以为豪的透明肌。她分享道：「我一直是SK-II的忠实用户，特别是神仙水已经用了快十年。能与自己深爱的品牌合作，感觉像美梦成真。」</p>
    <p>SK-II全球总裁Sue Kyung Lee表示：「佐佐木小姐身上有一种超越外表的内在光芒——她的真诚、她的坚韧、她对生活的热爱，正是SK-II品牌精神的最好诠释。」</p>
    <p>全新广告大片已于5月15日在东京、纽约、巴黎三地同步上线，佐佐木明希的形象出现在各大户外广告牌和时尚杂志中，引发广泛关注。</p>`,
    image: "https://readdy.ai/api/search-image?query=Japanese%20actress%20natural%20beauty%20portrait%20with%20dewy%20skin%2C%20minimal%20makeup%2C%20clean%20white%20background%2C%20elegant%20and%20fresh%20skincare%20advertisement%20style%2C%20soft%20radiant%20lighting%2C%20premium%20beauty%20photography&width=800&height=500&seq=skii-ambassador&orientation=landscape",
    tags: ["SK-II", "品牌大使", "广告", "护肤"],
    author: "编辑部",
    readTime: "4分钟",
  },
];

export const articlesByCategory = (categorySlug: string): Article[] => {
  return articles.filter((a) => a.category === categorySlug);
};

export const articleBySlug = (slug: string): Article | undefined => {
  return articles.find((a) => a.slug === slug);
};

export const latestArticles = (count: number = 6): Article[] => {
  return [...articles].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()).slice(0, count);
};